(() => {
  'use strict';

  const STORAGE_KEY = 'recently_viewed_products';
  const MAX_PRODUCTS = 20;

  class RecentlyViewed {
    constructor() {
      this.section = document.querySelector('[data-recently-viewed]');

      this.saveCurrentProduct();

      if (!this.section) return;

      this.grid = this.section.querySelector('#recently-viewed-grid');

      if (!this.grid) return;

      this.limit = Number(this.section.dataset.limit) || 4;

      this.loadProducts();
    }

    saveCurrentProduct() {
      if (!window.location.pathname.startsWith('/products/')) return;

      const handle = window.location.pathname
        .replace('/products/', '')
        .split('/')[0];

      let products = [];

      try {
        products = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {}

      products = products.filter((item) => item !== handle);

      products.unshift(handle);

      if (products.length > MAX_PRODUCTS) {
        products = products.slice(0, MAX_PRODUCTS);
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    }

    async loadProducts() {
      let handles = [];

      try {
        handles = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {}

      if (!handles.length) {
        this.section.style.display = 'none';
        return;
      }

      handles = handles.slice(0, this.limit);

      const requests = handles.map((handle) => this.fetchProduct(handle));

      const products = await Promise.all(requests);

      products
        .filter(Boolean)
        .forEach((product) => {
          this.grid.insertAdjacentHTML(
            'beforeend',
            this.renderProduct(product)
          );
        });

      if (!this.grid.children.length) {
        this.section.style.display = 'none';
      }
    }

    async fetchProduct(handle) {
      try {
        const response = await fetch(`/products/${handle}.js`);

        if (!response.ok) return null;

        return await response.json();
      } catch (e) {
        return null;
      }
    }

    money(price) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(price, Shopify.money_format);
      }

      return (price / 100).toFixed(2);
    }

    renderProduct(product) {
      const image = product.featured_image || '';

      const compare =
        product.compare_at_price > product.price
          ? `
          <span class="price-item price-item--regular">
              ${this.money(product.compare_at_price)}
          </span>`
          : '';

      const badge =
        product.compare_at_price > product.price
          ? `<span class="badge color-scheme-2">Sale</span>`
          : '';

      return `
<li class="grid__item">

<div class="card-wrapper product-card-wrapper">

<div class="card card--standard">

<div class="card__media">

<a href="/products/${product.handle}">

<img
src="${image}"
alt="${product.title}"
loading="lazy">

</a>

${badge}

</div>

<div class="card__content">

<div class="card__information">

<h3 class="card__heading h5">

<a href="/products/${product.handle}" class="full-unstyled-link">

${product.title}

</a>

</h3>

<div class="card-information">

<div class="price">

<div class="price__container">

<div class="price__regular">

<span class="price-item price-item--sale">

${this.money(product.price)}

</span>

${compare}

</div>

</div>

</div>

</div>

</div>

</div>

</div>

</div>

</li>
`;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new RecentlyViewed();
  });

})();